import { render, staticRenderFns } from "./dicListSelect.vue?vue&type=template&id=123c956f&scoped=true"
import script from "./dicListSelect.vue?vue&type=script&lang=js"
export * from "./dicListSelect.vue?vue&type=script&lang=js"
import style0 from "./dicListSelect.vue?vue&type=style&index=0&id=123c956f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123c956f",
  null
  
)

export default component.exports